import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; // Pastikan path ini benar
import { collection, query, orderBy, getDocs } from 'firebase/firestore'; // Pastikan import ini benar
import PageHeader from '../components/PageHeader';
import AnimatedSection from '../components/AnimatedSection';
import SEO from '../components/SEO';
import '../components/styles.css'; // Menggunakan stylesheet komponen umum

const EkstrakurikulerPage = () => {
  const [ekstrakurikuler, setEkstrakurikuler] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEkstrakurikuler = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, 'ekstrakurikuler'), orderBy('order', 'asc'));
        const querySnapshot = await getDocs(q);
        const ekstrakurikulerData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setEkstrakurikuler(ekstrakurikulerData);
      } catch (error) {
        console.error("Error fetching ekstrakurikuler data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEkstrakurikuler();
  }, []);

  return (
    <>
      <SEO 
        title="Ekstrakurikuler - SMK Pariwisata Sumbangsih"
        description="Kembangkan bakat dan minatmu melalui berbagai kegiatan ekstrakurikuler yang seru dan bermanfaat di SMK Pariwisata Sumbangsih, dari olahraga hingga seni."
      />
      <PageHeader 
        title="Ekstrakurikuler" 
        subtitle="Kembangkan bakat dan minatmu melalui berbagai kegiatan ekstrakurikuler yang seru dan bermanfaat." 
      />
      <AnimatedSection>
        <section className="section">
          <div className="container">
            {loading ? (
              <p style={{ textAlign: 'center' }}>Memuat data ekstrakurikuler...</p>
            ) : ekstrakurikuler.length > 0 ? (
              <div className="activity-grid">
                {ekstrakurikuler.map(item => (
                  <div key={item.id} className="activity-card">
                    <img src={item.image || 'https://via.placeholder.com/400x250'} alt={item.title} className="activity-image" />
                    <div className="activity-content">
                      <h3 className="activity-title">{item.title}</h3>
                      <p className="activity-description">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ textAlign: 'center' }}>Belum ada data ekstrakurikuler yang ditambahkan.</p>
            )}
          </div>
        </section>
      </AnimatedSection>
    </>
  );
};

export default EkstrakurikulerPage;